import { Button, FormControl, FormHelperText, MenuItem, Select } from '@material-ui/core';
import format from 'date-fns/format';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
import { RootStateType } from '../../../../redux-store/reducers';
import { BANK, ImageSaveType } from '../../../../redux-store/types/nct';
import {
    accountNumberRegex,
    accountNumberValidation,
    ACCOUNT_TYPE_MASTER_DATA,
    BANK_ACCOUNT_DETAILS,
    getBankAddress,
    ifscRegex,
    isAlphaNumeric,
    OTP_ACTIONS,
    validateIfsc,
} from '../../../../utils/constants';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import {
    sendPhoneOTP,
    fetchIFSCDetails,
    onSaveImageData,
    getAmcList,
} from '../../../../redux-store/actions/nct';
import { initialValues } from '../ChangeTaxStatus/change-bank-details';
import { NoteModals } from '../../../../lib/NoteModals';
import { ValidationUI } from '../MinorStatus/minor-status-edit-bank';
import { IfscModal } from '../../../../lib/NoteModals/ifscModal';
import { ActionHeader, FaqLink } from '..';
import { findDefaultBankIndex } from '.';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { isMobile } from '../../../quick-links/faq';
import { RTA_CODES } from '../../commercial/emandate/types';
const { dashboard, common } = en;

interface BANK_ACCOUNT_DETAILS extends BANK {
    amcName: string;
    primaryHolder: string;
    folioNo?: string;
}

type ACCOUNT_DETAILS = {
    key: string;
    label: string;
    value: string;
    onBlurFunction?: Function;
    isDisabled: boolean;
    fieldValidation?: Function;
    shouldValidateField?: boolean;
};

function ChangeBankSelected(props: any) {
    const { targetFunds } = props.location.state || {};
    const [bankDetails, setDetails] = useState<BANK_ACCOUNT_DETAILS[]>([]);
    const [newBankDetails, setNewDetails] = useState({
        accountNo: '',
        ifsc: '',
        name: '',
        accountType: 'SAVINGS',
        branch: '',
        city: '',
    });
    const [errors, setErrors] = useState<any>({});
    const [modalData, setShowModal] = useState<any>(initialValues);
    const [cheques, setCheques] = useState<any>({
        oldCheque: { name: 'OldCheque', format: '', content: '' },
        newCheque: { name: 'NewCheque', format: '', content: '' },
    });
    const [showAlertModal, setAlertModal] = useState<{ deleteType: string; showModal: boolean }>({
        deleteType: '',
        showModal: false,
    });
    const folioRef = useRef<string>();

    const [showLoader, setLoader] = useState<boolean>(false);
    const [ifscValidation, setValidation] = useState<boolean>(false);
    const dispatch = useDispatch();

    const [amcList, setAmcList] = useState<any[]>([]);

    useEffect(() => {
        const fetchAmcList = async () => {
            try {
                const { body: amcListResponse } = await getAmcList()(dispatch);
                setAmcList(amcListResponse);
            } catch (error) {
                console.error('Error fetching AMC list:', error);
            }
        };
        fetchAmcList();
    }, [dispatch]);

    useEffect(() => {
        if (shouldShowInvestorSignature(targetFunds, amcList) && !cheques.investorSignature) {
            setCheques((prevState: any) => ({
                ...prevState,
                investorSignature: { name: 'First holder signature', format: '', content: '' },
            }));
        }
    }, [amcList]);

    const shouldShowInvestorSignature = (
        targetFunds: ConsolidateTableRowType[],
        amcList: any[],
    ) => {
      // Show Investor Signature for CAMS and KFIN
      return true;
        // const selectedAmcs = targetFunds.map((_ele: ConsolidateTableRowType) => _ele.amc);
        // for (let i = 0; i < selectedAmcs.length; i++) {
        //     const rtaCode = amcList.find((item) => item.amc_code === selectedAmcs[i])?.rta_code;
        //     if (rtaCode === RTA_CODES.CAMS) {
        //         return true;
        //     }
        // }
        // return false;
    };

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        const { targetFunds } = props.location.state || {};
        setDetails(
            targetFunds.map((_ele: ConsolidateTableRowType) => {
                const validBankIndex = findDefaultBankIndex(_ele);
                return {
                    amcName: _ele.amcName,
                    primaryHolder: _ele.investorName,
                    folioNo: _ele.folio,
                    ..._ele.bank[validBankIndex],
                };
            }),
        );
    }, []);

    useEffect(() => {
        const { ifsc } = newBankDetails;
        setLoader(false);
        if (ifsc.length === 11) {
            document.getElementById('ifsc')?.blur();
            _getIFSCDetails();
        } else {
            setNewDetails({
                ...newBankDetails,
                name: '',
                branch: '',
                city: '',
            });
        }
    }, [newBankDetails.ifsc]);

    const handleRemoveBankDetails = (index: number) => {
        const filteredData = bankDetails.filter(
            (_ele: BANK_ACCOUNT_DETAILS, ind: number) => ind !== Number(folioRef.current),
        );
        setAlertModal({
            showModal: false,
            deleteType: '',
        });
        if (filteredData.length === 0) {
            setAlertModal({
                deleteType: 'deletedAllFolios',
                showModal: true,
            });

            return;
        }
        setDetails(filteredData);
    };

    const _handleTextInputChange = (key: string, value: any) => {
        setNewDetails({
            ...newBankDetails,
            [key]: value,
        });
    };

    const validateForm = () => {
        let validForm: boolean = true;
        let errors: any = {};
        if (!accountNumberRegex.test(newBankDetails.accountNo)) {
            validForm = false;
            errors['accountNo'] = common.errors.bankErrors.accountNo.regexError;
        }
        if (newBankDetails.accountType === dashboard.ChangeBank.selectedFolios.fields.accountType) {
            errors['accountType'] = common.errors.bankErrors.accountType;
            validForm = false;
        }
        setErrors(errors);
        return validForm;
    };

    // save images in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: shouldShowInvestorSignature(targetFunds, amcList)
                    ? [cheques.oldCheque, cheques.newCheque, cheques.investorSignature]
                    : [cheques.oldCheque, cheques.newCheque],
                type: 'CHANGE_BANK',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [cheques]);

    const handleSubmit = async () => {
        if (validateForm()) {
            const { targetFunds } = props.location.state;
            const { pan, pekrn, mobile } = props;
            const [fund] = targetFunds;
            const { bank } = fund;
            const [bankData] = bank;
            const { accountNo: sourceAccountNo, ifsc: sourceIFSC } = bankData;
            const { accountNo: targetAccountNo, ifsc: targetIFSC } = newBankDetails;
            if (sourceAccountNo === targetAccountNo) {
                setNewDetails({
                    ...newBankDetails,
                    accountNo: '',
                    ifsc: '',
                    name: '',
                    branch: '',
                    city: '',
                });
                alert(common.errors.bankErrors.sameBankDetails);
                return;
            }
            const data = targetFunds.map((_ele: ConsolidateTableRowType) => ({
                amc: _ele.amc,
                folio: _ele.folio,
                bankDetails: {
                    ...newBankDetails,
                },
            }));
            try {
                let res = await props.sendPhoneOTP({
                    mobile,
                    pan,
                    pekrn,
                    action: OTP_ACTIONS.changeBankDetails,
                });
                props.history.replace('change-bank-otp', {
                    data,
                    // images: [cheques.oldCheque, cheques.newCheque],
                    mobile: props.mobile,
                    pan: props.pan,
                    ...(res || {}).body,
                });
            } catch (err: any) {
                alert(err.message);
            }
        }
    };

    const _handleChangeBankDetails = (
        resetValues: boolean = false,
        showModal: boolean = false,
        bankName: string = '',
        bankAddress: string = '',
        city: string = '',
    ) => {
        setShowModal({
            showModal: showModal,
            name: bankName,
            branch: bankAddress,
            city: city,
        });
        if (resetValues) {
            setNewDetails({
                ...newBankDetails,
                name: '',
                branch: '',
                city: '',
            });
        }
    };

    const _getIFSCDetails = async () => {
        if (newBankDetails.ifsc.match(ifscRegex)) {
            setValidation(true);
            setLoader(true);
            const { pan, pekrn, mobile, reqId } = props;
            try {
                let response: any = await props.fetchIFSCDetails({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                    ifscCode: newBankDetails.ifsc,
                });
                const { errors = [], data = [] } = (response || {}).body;
                if (errors.length) {
                    const [firstError] = errors;
                    throw Error(firstError?.message);
                }
                const [details] = data;
                const { BankAdd1 = '', BankAdd2 = '', BankAdd3 = '' } = details;
                _handleChangeBankDetails(
                    false,
                    true,
                    details.BankName,
                    getBankAddress(BankAdd1, BankAdd2, BankAdd3),
                    details.BankCity,
                );
                setValidation(false);
            } catch (e: any) {
                setLoader(false);
                setValidation(false);
                _handleChangeBankDetails(true);
                setErrors({ ifsc: e.message });
            }
        }
    };

    const validateIfscWithRegex = (value: string) => {
        if (!value.match(ifscRegex)) {
            setLoader(false);
            setValidation(false);
            _handleChangeBankDetails(true);
            setErrors({ ifsc: common.errors.bankErrors.ifsc.regex });
        }
    };

    const _getBankInfo = () => {
        const { name = '', branch = '', city = '' } = modalData;
        return [name, branch, city].join(',');
    };

    const _handleProceed = () => {
        const { name = '', branch = '', city = '' } = modalData;
        setNewDetails({
            ...newBankDetails,
            name,
            branch,
            city,
        });
        setShowModal(initialValues);
    };

    const _handleModalClose = () => {
        setShowModal(false);
        setNewDetails({
            ...newBankDetails,
            ifsc: '',
            name: '',
            branch: '',
            city: '',
        });
    };

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                callBackFn={() => {}}
                triggerCheck={true}
                trxnType={NFT_TRXN_TYPE_MAP.changeBankDetails}
                foliosArray={targetFunds}
            />
            <ActionHeader header={dashboard.ChangeBank.ChangeBankHeading} />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner">
                    <div
                        className="curved-bg-content-inner-top"
                        style={{
                            minHeight: 'auto',
                        }}
                    >
                        <p>{dashboard.ChangeBank.selectedFolios.subheading}</p>
                        {bankDetails.map((_ele: BANK_ACCOUNT_DETAILS, ind: number) => (
                            <div className="selected-folios-list">
                                <h3>{_ele.amcName}</h3>
                                <a className="delete-folio">
                                    <img
                                        src="/images/delete-folio.svg"
                                        alt="delete icon"
                                        onClick={() => {
                                            folioRef.current = ind.toString();
                                            setAlertModal({
                                                deleteType: 'deleteFolio',
                                                showModal: true,
                                            });
                                        }}
                                    />
                                </a>
                                <div className="selected-folios-list-bottom">
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.primaryHolder}
                                        <span>{_ele.primaryHolder}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.ifsc}
                                        <span>{_ele.ifsc || _ele.neftIfsc}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.accountNo}
                                        <span>{_ele.accountNo}</span>
                                    </p>
                                    <p>
                                        {dashboard.ChangeBank.selectedFolios.folioNo}
                                        <span>{_ele.folioNo}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="add-new-bankAccount">
                        <h4>{dashboard.ChangeBank.selectedFolios.addNewBankHeading}</h4>
                        <p>{dashboard.ChangeBank.selectedFolios.addNewBankHeadingInfo}</p>
                        <div className="new-bank-fields change-bank-selected-fields">
                            {[
                                {
                                    key: 'accountNo',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountNumber,
                                    value: newBankDetails.accountNo,
                                    isDisabled: false,
                                    fieldValidation: accountNumberValidation,
                                },
                                {
                                    key: 'ifsc',
                                    label: dashboard.ChangeBank.selectedFolios.fields.ifsc,
                                    value: newBankDetails.ifsc,
                                    onBlurFunction: validateIfscWithRegex,
                                    isDisabled: false,
                                    shouldValidateField: true,
                                    fieldValidation: validateIfsc,
                                },
                                {
                                    key: 'name',
                                    label: dashboard.ChangeBank.selectedFolios.fields.bankName,
                                    value: newBankDetails.name,
                                    isDisabled: true,
                                },
                                {
                                    key: 'accountType',
                                    label: dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    value:
                                        newBankDetails.accountType ||
                                        dashboard.ChangeBank.selectedFolios.fields.accountType,
                                    isDisabled: false,
                                },
                                {
                                    key: 'branch',
                                    label: dashboard.ChangeBank.selectedFolios.fields.branch,
                                    value: newBankDetails.branch,
                                    isDisabled: true,
                                },
                                {
                                    key: 'city',
                                    label: dashboard.ChangeBank.selectedFolios.fields.city,
                                    value: newBankDetails.city,
                                    isDisabled: true,
                                },
                            ].map((_ele: ACCOUNT_DETAILS) =>
                                _ele.key === 'accountType' ? (
                                    <FormControl variant="outlined" error={!!errors[_ele.key]}>
                                        <Select
                                            labelId="portfolio-sortby-label"
                                            id="portfolio-sortby"
                                            name={'accountType'}
                                            value={_ele.value}
                                            onChange={(e) => {
                                                _handleTextInputChange(_ele.key, e.target.value);
                                            }}
                                            // readOnly={true}
                                        >
                                            <MenuItem value={_ele.label}>{_ele.label}</MenuItem>
                                            {ACCOUNT_TYPE_MASTER_DATA.map((type: string) => (
                                                <MenuItem value={type}>{type}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText
                                            className={!!errors[_ele.key] ? 'error' : ''}
                                        >
                                            {errors[_ele.key]}
                                        </FormHelperText>
                                    </FormControl>
                                ) : (
                                    <FormControl variant="outlined">
                                        <TextInput
                                            variant="outlined"
                                            label={_ele.label}
                                            value={_ele.value.toUpperCase()}
                                            name={_ele.key}
                                            id={_ele.key}
                                            onChange={(e: any) => {
                                                if (_ele.fieldValidation) {
                                                    _ele.fieldValidation(e.target.value)
                                                        ? _handleTextInputChange(
                                                              _ele.key,
                                                              e.target.value,
                                                          )
                                                        : null;
                                                    return;
                                                }
                                                _handleTextInputChange(_ele.key, e.target.value);
                                            }}
                                            onFocus={() => setErrors({})}
                                            error={!!errors[_ele.key]}
                                            onBlur={() => {
                                                if (_ele.onBlurFunction) {
                                                    _ele.onBlurFunction(_ele.value);
                                                }
                                            }}
                                            helperText={errors[_ele.key]}
                                            disabled={_ele.isDisabled}
                                            title={!!_ele.isDisabled ? _ele.value : ''}
                                        />
                                        {_ele.shouldValidateField && showLoader && (
                                            <FormHelperText>
                                                <ValidationUI
                                                    isValidating={ifscValidation}
                                                    onValidationText={common.validatingIFSC}
                                                    successfulValidationText={common.IFSCValidated}
                                                />
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                ),
                            )}
                        </div>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <h4>{dashboard.ChangeBank.selectedFolios.uploadDocuments}</h4>
                        <p>{dashboard.ChangeBank.selectedFolios.uploadDocumentsInfo}</p>
                        <p style={{ marginTop: '-15px', marginBottom: '0px' }}>
                            {dashboard.ChangeBank.selectedFolios.requiredDocumentInfo}
                        </p>
                        <div className="selected-folios-btn bank-selected-folios-bottom">
                            <div className="change-bank-upload">
                                <div className="change-bank-upload-inner">
                                    <div className="change-bank-upload-single">
                                        <p style={{ color: '#1A237E', fontWeight: 'bold' }}>
                                            Old Bank Account Details
                                        </p>
                                        <p className="upload-description">
                                            Upload old bank account required document registered
                                            with the folio.
                                        </p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        ...cheques,
                                                        oldCheque: {
                                                            ...cheques.oldCheque,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                                id={'oldCheque'}
                                            />
                                        </div>
                                    </div>
                                    <div className="change-bank-upload-single">
                                        <p style={{ color: '#1A237E', fontWeight: 'bold' }}>
                                            New Bank Account Details
                                        </p>
                                        <p className="upload-description">
                                            Upload new bank account required document to be
                                            registered with the folio.
                                        </p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        ...cheques,
                                                        newCheque: {
                                                            ...cheques.newCheque,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                                id={'newCheque'}
                                            />
                                        </div>
                                    </div>
                                    {shouldShowInvestorSignature(targetFunds, amcList) && (
                                        <div className="change-bank-upload-single">
                                            <p style={{ color: '#1A237E', fontWeight: 'bold' }}>
                                                Investor Signature
                                            </p>
                                            <p className="upload-description">
                                                Upload investor's signature image in prescribed
                                                format
                                            </p>
                                            <div className="bank-selected-upload-fields">
                                                <UploadFile
                                                    onImageSelected={(value, format) => {
                                                        setCheques({
                                                            ...cheques,
                                                            investorSignature: {
                                                                ...cheques.investorSignature,
                                                                format: format,
                                                                content: value,
                                                            },
                                                        });
                                                    }}
                                                    id={'investorSignature'}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <FaqLink section={BANK_ACCOUNT_DETAILS} history={props.history} />
                                <Button
                                    className="customBtn"
                                    disabled={
                                        !Object.values(newBankDetails).every((_ele) => !!_ele) ||
                                        !Object.values(cheques).every((_ele: any) => !!_ele.content)
                                    }
                                    onClick={handleSubmit}
                                >
                                    {dashboard.ChangeBank.selectedFolios.buttonText}
                                </Button>
                                {modalData.showModal && (
                                    <IfscModal
                                        extraClass="ifsc-modal"
                                        showModal={modalData.showModal}
                                        heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
                                        info1={dashboard.UpdateIFSC.noteModals.bankName}
                                        info2={dashboard.UpdateIFSC.noteModals.ifscCode}
                                        info3={dashboard.UpdateIFSC.noteModals.city}
                                        info4={dashboard.UpdateIFSC.noteModals.branch}
                                        content1={modalData.name}
                                        content2={newBankDetails.ifsc}
                                        content3={modalData.city}
                                        content4={modalData.branch}
                                        proceedBtn={dashboard.UpdateIFSC.noteModals.proceedText}
                                        onProceed={_handleProceed}
                                        cancelBtn={dashboard.UpdateIFSC.noteModals.cancelText}
                                        onCancel={_handleModalClose}
                                    />
                                )}
                                <NoteModals
                                    showModal={showAlertModal.showModal}
                                    heading={dashboard.noteModals.nctModal.heading}
                                    info={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? dashboard.noteModals.bank.info
                                            : dashboard.ChangeTaxStatus.noteModals.confirmationText
                                    }
                                    proceedBtn={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? dashboard.noteModals.okayTxt
                                            : dashboard.noteModals.otpModal.proceedText
                                    }
                                    cancelBtn={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? ''
                                            : dashboard.noteModals.otpModal.cancelText
                                    }
                                    onProceed={
                                        showAlertModal.deleteType === 'deletedAllFolios'
                                            ? () => props.history.goBack()
                                            : handleRemoveBankDetails
                                    }
                                    onCancel={() => {
                                        setAlertModal({
                                            deleteType: '',
                                            showModal: false,
                                        });
                                        folioRef.current = '';
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    fetchIFSCDetails,
    onSaveImageData,
})(ChangeBankSelected);
